import { Image } from './Image'
import { Sku } from './Sku'
import { Project } from './Project'
import { Shipping } from './Shipping'
import { AttributeGroup } from './Attribute'
import { Agreement } from './Agreement'
import moment, { Moment } from 'moment'

export interface ProductStatDTO {
  eventCount: number
  productId: number
  productName: string
  revenue: number
}

export interface ProductDTO {
  id: number
  brandId: number
  brandName?: string
  name: string
  info: string
  tags: string
  images: Image[]
  mainImage: Image
  productSkus: Sku[]
  createdDate: Date
  numberSkus: number
  attGroups: AttributeGroup[]
  relatedMedia: Project[]
  shippings: Shipping[]
  projects: Project[]
  agreements: Agreement[]
  loadContents?: boolean
  loadProjects?: boolean
}
export class Product {
  id: number
  externalId: number | string;
  brandId: number
  brandName?: string
  name: string
  info: string
  tags: string
  images: Image[]
  mainImage: Image
  productSkus: Sku[]
  createdDate: Date
  numberSkus: number
  attGroups: AttributeGroup[]
  relatedMedia: Project[]
  shippings: Shipping[]
  projects: Project[]
  agreements: Agreement[]
  removable: boolean

  constructor (product: ProductDTO) {
    for (const property in product) {
      this[property] = product[property]
    }
  }

  get imageUrl () {
    if (this.mainImage && this.mainImage.url) return this.mainImage.url
    if (this.images && this.images[0] && this.images[0].url) return this.images[0].url
    return null
  }

  get tagsAsArray () {
    return this.tags
      ? this.tags.split(',')
      : []
  }

  get asDTO (): ProductDTO {
    return {
      agreements: this.agreements,
      attGroups: this.attGroups,
      brandId: this.brandId,
      createdDate: this.createdDate,
      id: this.id,
      images: this.images,
      info: this.info,
      mainImage: this.mainImage,
      name: this.name,
      numberSkus: this.numberSkus,
      productSkus: this.productSkus,
      projects: this.projects,
      relatedMedia: this.relatedMedia,
      shippings: this.shippings,
      tags: this.tags,
      brandName: this.brandName
    }
  }
}

export interface ProductsTableEntryDTOInterface {
  id: number
  name: string
  brandName: string
  createdDate: string
  tags: string
  skuCount: number
  images: Image[]
  projects: { [key: string]: string[] }
  agreements: { [key: string]: string[] }
  agreementDTOMap: { [key: string]: Agreement }
  shopifyAccessToken?: string
  shopifyStoreUrl?: string
}

export class ProductTableEntryDTO {
  readonly id: number
  readonly name: string
  readonly brandName: string
  readonly createdDate: Moment
  readonly tags: string
  readonly skuCount: number
  readonly images: Image[]
  readonly projects: Map<string, Set<string>>
  readonly agreements: Map<string, Set<string>>
  readonly agreementDTOMap: Map<string, Agreement>

  constructor (product: ProductsTableEntryDTOInterface) {
    this.id = product.id
    this.name = product.name
    this.brandName = product.brandName
    this.createdDate = moment(product.createdDate)
    this.tags = product.tags
    this.skuCount = product.skuCount
    this.images = product.images
    this.projects = new Map(
      Object.entries(product.projects || {})
        .map(([projectName, agreementNamesArr]) => ([
          projectName,
          new Set(agreementNamesArr)
        ]))
    )
    this.agreements = new Map(
      Object.entries(product.agreements || {})
        .map(([agreementName, projectNamesArr]) => ([
          agreementName,
          new Set(projectNamesArr)
        ]))
    )
    this.agreementDTOMap = new Map(
      Object.entries(product.agreementDTOMap || {})
        .map(([agreementName, agreement]) => ([
          agreementName,
          new Agreement(agreement)
        ]))
    )
  }
}
